import { BaseComponentDrawer } from '../../../core/abstraction/BaseComponentDrawer';

export class BaseBonusBoardDrawer extends BaseComponentDrawer {

}
